export default __webpack_public_path__ + "static/media/logout.fc2ca37a.svg";